import React from 'react';
import { useReactiveVar } from '@apollo/client';
import { ThemeProvider } from 'styled-components';
import { SnackbarProvider } from 'notistack';
import theme from './styles/theme';
import GlobalStyle from './styles/GlobalStyles';
import { useSnackbarStyles } from './styles/useStyles';
import SnackbarCloseBtnPresenter from './styles/SnackbarCloseBtnPresenter';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/styles';
import { snackbarBottom } from '@vars';

const ProviderPresenter: React.FC = ({ children }) => {
  const bottom = useReactiveVar(snackbarBottom);

  return (
    <MuiThemeProvider theme={theme}>
      <ThemeProvider theme={theme}>
        <SnackbarProvider
          classes={{
            ...useSnackbarStyles({ marginBottom: bottom })
          }}
          maxSnack={3}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          hideIconVariant={true}
          action={(key) => <SnackbarCloseBtnPresenter snackbarKey={key} />}
        >
          <GlobalStyle />
          {children}
        </SnackbarProvider>
      </ThemeProvider>
    </MuiThemeProvider>
  );
};

export default ProviderPresenter;
